import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { LoggingMessageService } from '../services/logging-message.service';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private domain: string;
    private subscriptionKey: string;

    constructor(private http: HttpClient, private logger: LoggingMessageService, private authService: AuthService, private cookieService: CookieService, private subscriptionService: SubscriptionChangeService) {
        this.domain = environment.WebServer;
        this.subscriptionKey = environment.SubscriptionSelected;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.logger.debug('token.interceptor', 'intercept',  this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString ,`Url:${req.url}`, '');

        const useCookies = environment.UseCookies;
        const cookiesEnabled = (useCookies && (useCookies === true));
        if (cookiesEnabled === true) {
            req = this.addCredentialsToHeader(req);

            // Can't get the token from here. Set cookie in requestToken response ????
            // const token = this.authService.getAccessToken();
            // const expiry = this.authService.getAccessTokenExpiry(token);
            // const exp: number | Date = new Date(expiry);
            // this.cookieService.set(environment.CookieName, token, exp, '/', null, false, 'Strict');
        }

        const isLoggedIn = this.authService.isUserLoggedIn();
        const userreg = req.url.toLowerCase().includes('userregistration');
        const fedtoken = req.url.toLowerCase().includes('federationtoken');
        const subscription = this.getSubscription();

        let token = '';
        if ((cookiesEnabled === false) && (isLoggedIn === true) && (userreg === false) && (fedtoken === false)) {
            token = this.authService.getAccessToken();
            req = this.addTokenToHeader(req, token, subscription);
        }
        if ((isLoggedIn === true) && (userreg === true)) {
            token = this.authService.getFederationToken();
            req = this.addTokenToHeader(req, token, subscription);
        }
        if ((cookiesEnabled === true) && (isLoggedIn === true)) {
            req = this.addSubscriptionToHeader(req, subscription);
        }

        return next.handle(req);
    }

    private addCredentialsToHeader(req: HttpRequest<any>): HttpRequest<any> {
        req = req.clone({
            withCredentials: true,
        });
        return req;
    }

    private addTokenToHeader(req: HttpRequest<any>, token: any, subscription: string): HttpRequest<any> {
        req = req.clone({
            withCredentials: true,
            setHeaders: {
                Authorization: token,
                'subscription': subscription
            }
        });
        return req;
    }

    private addSubscriptionToHeader(req: HttpRequest<any>, subscription: string): HttpRequest<any> {
        req = req.clone({
            setHeaders: {
                'subscription': subscription
            }
        });
        return req;
    }

    private getSubscription(): string {
        let subid = sessionStorage.getItem(this.subscriptionKey);
        subid = (subid) ? subid : '';
        return subid;
    }

    // private addToHeader(req: HttpRequest<any>, token: any, userid: string, role: string): HttpRequest<any> {
    //     req = req.clone({
    //         withCredentials: true,
    //         setHeaders: {
    //             Authorization: token,
    //             User: userid,
    //             Role: role
    //         }
    //     });
    //     return req;
    // }

    // private getUserId(): string {
    //     // let userid = sessionStorage.getItem(environment.PendoUserRole);
    //     let userid = sessionStorage.getItem(environment.UserID);
    //     userid = (userid) ? userid : '';
    //     return userid;
    // }

    // private getUserRole(): string {
    //     let userRole = sessionStorage.getItem(environment.TokenUserRole);
    //     userRole = (userRole) ? userRole : '';
    //     return userRole;
    // }

    // private logMessage(message: string) {
    //     setTimeout(() => {
    //         const user = this.authService.getUser();
    //         this.logger.debug(user, 'TokenInterceptor', message);
    //     }, 0);
    // }
}
